<template>
  <div class="container my-4">
    <div v-if="isFirstLoading" class="spinner-wrapper">
      <div class="spinner"></div>
    </div>

    <template v-else>
      <div class="row px-md-5 align-items-start">
        <div class="col-md-5 order-md-first order-last">
          <!-- Beginning Title -->
          <div class="row justify-content-center my-3 mt-lg-0">
            <div class="col">
              <h2>
                {{ getTransactionType(selectedEstate.transaction_type) }}
                {{ getEstateType(selectedEstate.estate_type) }} در
                {{ getRegion(selectedEstate.region) }}
              </h2>
            </div>
          </div>
          <!-- End Title -->

          <!-- Beginning Contacts -->
          <div class="d-none d-lg-block d-flex justify-content-start">
            <button
                @click="errorEstate"
                type="button"
                class="btn btn-lg mb-5"
                style="background-color: rgb(91, 192, 190)"
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
            >
              <span class="text-light"> اطلاعات تماس </span>
            </button>
          </div>
          <!-- End Contacts -->

          <button
              @click="errorEstate"
              type="button"
              class="btn position-fixed fixed-bottom btn-lg d-md-none rounded-0 text-light"
              style="background-color: rgb(91, 192, 190);height: 50px"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
          >
            اطلاعات تماس
          </button>
          <div
              class="modal fade"
              id="exampleModal"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                    شماره همراه
                  </h5>
                  <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                  ></button>
                </div>
                <div class="modal-body fs-2 text-center">
                  <span v-if="full_name != null" class="h5 me-5">{{ full_name }}</span>
                  <a
                      v-if="numberphone != null"
                      class="text-muted"
                      :href="`tel:${numberphone}`"
                  >
                    {{ numberphone }}
                  </a>
                  <span v-if="numberphone == null" class="text-danger">{{ errorMessege }}</span>
                </div>
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn col-12 text-light"
                      style="background-color: rgb(91, 192, 190)"
                      data-bs-dismiss="modal"
                  >
                    بستن
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Beginning Mandatory field -->
          <div
              class="row mb-3"
              v-if="
            selectedEstate.estate_type != 'EARTH' &&
            selectedEstate.transaction_type != 'PARTNERSHIP'
          "
          >
            <div class="col-md-12">
              <div class="d-flex justify-content-evenly">
                <div
                    class="d-flex flex-column justify-content-center align-items-center"
                    v-if="selectedEstate.area != null"
                >
                  <span class="text-muted">متراژ</span>
                  <span class="h2"> {{ selectedEstate.area }}</span>
                </div>
                <div class="vr"></div>
                <div
                    class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span class="text-muted">اتاق</span>
                  <span class="h2" v-if="selectedEstate.count_sleep_room != null">
                  {{ selectedEstate.count_sleep_room }}</span
                  >
                  <span class="h5" v-else>بدون اتاق</span>
                </div>
                <div
                    class="vr"
                    v-if="
                  selectedEstate.estate_type != 'EARTH' &&
                  selectedEstate.transaction_type != 'PARTNERSHIP' &&
                  selectedEstate.transaction_type != 'PRESELL'
                "
                ></div>
                <div
                    class="d-flex flex-column justify-content-center align-items-center"
                    v-if="
                  selectedEstate.estate_type != 'EARTH' &&
                  selectedEstate.transaction_type != 'PARTNERSHIP' &&
                  selectedEstate.transaction_type != 'PRESELL'
                "
                >
                  <span class="text-muted">سال ساخت</span>
                  <span class="h2" v-if="selectedEstate.age != null">
                  {{ selectedEstate.age }}</span
                  >
                </div>
              </div>
            </div>
            <div class="col-12">
              <hr/>
            </div>
          </div>
          <!-- End Mandatory field -->

          <!-- Beginning Price and rent -->
          <div
              class="row"
              v-if="selectedEstate.transaction_type != 'PARTNERSHIP' && selectedEstate.with_price"
          >
            <div class="col-12">
              <div>
                <div
                    class="d-flex justify-content-between px-5"
                    v-if="selectedEstate.estate_type == 'EARTH'"
                >
                <span class="h5 text-muted" v-if="selectedEstate.area != null">
                  متراژ :
                </span>
                  <span class="h5">{{ selectedEstate.area }}</span>
                </div>
                <div class="col-12" v-if="selectedEstate.estate_type == 'EARTH'">
                  <hr/>
                </div>
                <div
                    class="d-flex justify-content-between px-5"
                    v-if="selectedEstate.transaction_type != 'RENT'"
                >
                  <span class="h5 text-muted">قیمت کل :</span>
                  <span class="h5" v-if="selectedEstate.amount != null">
                  {{
                      new Intl.NumberFormat().format(selectedEstate.amount)
                    }}</span
                  >
                </div>
                <div class="d-flex justify-content-between px-5" v-else>
                  <span class="h5 text-muted">ودیعه :</span>
                  <span class="h5" v-if="selectedEstate.amount != null">
                  {{ new Intl.NumberFormat().format(selectedEstate.amount) }}
                </span>
                  <span class="h5" v-if="selectedEstate.amount == null"
                  >توافقی</span
                  >
                </div>
              </div>
            </div>
            <div class="col-12">
              <hr/>
            </div>
            <div class="col-12">
              <div>
                <div
                    class="d-flex justify-content-between px-5"
                    v-if="selectedEstate.transaction_type != 'RENT'"
                >
                  <span class="h5 text-muted">قیمت هر متر :</span>
                  <span class="h5" v-if="pricePerMeter != null">
                  {{ pricePerMeter }}</span
                  >
                </div>
                <div class="d-flex justify-content-between px-5" v-else>
                  <span class="h5 text-muted">اجاره ماهانه :</span>
                  <span
                      class="h5"
                      v-if="
                    selectedEstate.transaction_type != 'SALE' &&
                    selectedEstate.rent_amount != null
                  "
                  >
                  {{
                      new Intl.NumberFormat().format(selectedEstate.rent_amount)
                    }}
                </span>
                  <span
                      class="h5"
                      v-if="
                    selectedEstate.amount != null &&
                    selectedEstate.rent_amount == null
                  "
                  >
                  0
                </span>
                  <span
                      class="h5"
                      v-if="
                    selectedEstate.amount == null &&
                    selectedEstate.rent_amount == null
                  "
                  >توافقی</span
                  >
                </div>
              </div>
            </div>
            <div class="col-12">
              <hr/>
            </div>
          </div>
          <!-- End Price and rent -->
          <div
              class="col-12"
              v-if="
              selectedEstate.estate_type != 'EARTH' &&
              selectedEstate.transaction_type != 'PARTNERSHIP' &&
              selectedEstate.estate_type != 'COMMERCIAL_OFFICE' &&
              selectedEstate.estate_type != 'VILLA'
            "
          >
            <template v-if="selectedEstate.floor != null">
              <div
                  class="d-flex justify-content-between px-5"
                  v-if="selectedEstate.floor != null"
              >
                <span class="h5 text-muted">طبقه :</span>
                <span class="h5" v-if="selectedEstate.floor == '0'">همکف</span>
                <span class="h5" v-else>{{ selectedEstate.floor }}</span>
              </div>
            </template>
          </div>
          <div
              class="col-12"
              v-if="
              selectedEstate.estate_type != 'EARTH' &&
              selectedEstate.transaction_type != 'PARTNERSHIP' &&
              selectedEstate.estate_type != 'COMMERCIAL_OFFICE' &&
              selectedEstate.estate_type != 'VILLA'
            "
          >
            <div class="row justify-content-center">
              <div class="col-12">
                <hr/>
              </div>
            </div>
          </div>

          <!-- Beginning Possibilities -->
          <div
              class="row mb-3"
              v-if="
            selectedEstate.estate_type != 'EARTH' &&
            selectedEstate.transaction_type != 'PARTNERSHIP'
          "
          >
            <div class="col-md-12">
              <div class="d-flex justify-content-evenly">
                <div
                    class="d-flex flex-column justify-content-center align-items-center"
                    v-if="
                  selectedEstate.has_elevator != null &&
                  selectedEstate.estate_type != 'EARTH'
                "
                >
                  <span class="text-muted">آسانسور</span>
                  <span class="h5" v-if="selectedEstate.has_elevator == '1'">
                  دارد</span
                  >
                  <span class="h5" v-else>ندارد</span>
                </div>
                <div class="vr"></div>
                <div
                    class="d-flex flex-column justify-content-center align-items-center"
                    v-if="
                  selectedEstate.has_parking != null &&
                  selectedEstate.estate_type != 'EARTH'
                "
                >
                  <span class="text-muted">پارکینگ</span>
                  <span class="h5" v-if="selectedEstate.has_parking != null">
                  دارد</span
                  >
                  <span class="h5" v-else>ندارد</span>
                </div>
                <div class="vr"></div>
                <div
                    class="d-flex flex-column justify-content-center align-items-center"
                    v-if="
                  selectedEstate.has_warehouse != null &&
                  selectedEstate.estate_type != 'EARTH'
                "
                >
                  <span class="text-muted">انباری</span>
                  <span class="h5" v-if="selectedEstate.has_warehouse == '1'">
                  دارد</span
                  >
                  <span class="h5" v-else>ندارد</span>
                </div>
                <div class="vr"></div>
                <div
                    class="d-flex flex-column justify-content-center align-items-center"
                    v-if="
                  selectedEstate.has_terrace != null &&
                  selectedEstate.estate_type != 'EARTH'
                "
                >
                  <span class="text-muted">تراس</span>
                  <span class="h5" v-if="selectedEstate.has_terrace == '1'">
                  دارد</span
                  >
                  <span class="h5" v-else>ندارد</span>
                </div>
              </div>
            </div>
            <div class="col-12">
              <hr/>
            </div>
          </div>
          <!-- End Possibilities -->

          <!-- Beginning Address -->
          <div class="row justify-content-center mb-4" v-if="selectedEstate.with_address && selectedEstate.address">
            <div class="col-10">
              <div class="d-flex flex-column justify-content-end">
                <h4>آدرس</h4>
                <span style="white-space: pre-wrap">{{
                    selectedEstate.address
                  }}</span>
              </div>
            </div>
          </div>
          <!-- End Address -->

          <!-- Beginning Description -->
          <div class="row justify-content-center pb-5" v-if="selectedEstate.with_description && selectedEstate.description">
            <div class="col-10">
              <div class="d-flex flex-column justify-content-end">
                <h4>توضیحات</h4>
                <span>کد فایل : {{ selectedEstate.id }}</span>
                <span style="white-space: pre-wrap">{{
                    selectedEstate.description
                  }}</span>
              </div>
            </div>
          </div>
          <!-- End Description -->
        </div>
        <div class="col-md-7 order-md-last order-first">
          <div class="row">
            <div class="col text-center">
              <template v-if="!selectedEstate.with_images">
                <img
                    src="../assets/images/about-us/homeplus.jpg"
                    class="card-img-top image-estate rounded mb-3"
                    alt="..."
                    title=""
                    style="object-fit: cover; height: auto"
                />
              </template>
              <template v-else>
                <img
                    v-if="selectedEstate.image.length === 0"
                    src="../assets/images/about-us/homeplus.jpg"
                    class="card-img-top image-estate rounded mb-3"
                    alt="..."
                    title=""
                    style="object-fit: cover; height: auto"
                />

                <template v-else>
                  <Carousel
                      id="gallery"
                      :items-to-show="1"
                      :wrap-around="true"
                      v-model="currentSlide"
                  >
                    <Slide v-for="slide in selectedEstate.image" :key="slide">
                      <img
                          :src="slide.src"
                          class="d-block w-75 img-fluid rounded carousel__item"
                          alt="..."
                          width="500"
                          title=""
                          style="object-fit: cover"
                      />
                    </Slide>
                    <template #addons>
                      <Pagination/>
                    </template>
                  </Carousel>

                  <Carousel
                      dir="rtl"
                      id="thumbnails"
                      :items-to-show="4"
                      :wrap-around="true"
                      v-model="currentSlide"
                      ref="carousel"
                  >
                    <Slide
                        v-for="(slide, key) in selectedEstate.image"
                        :key="slide"
                    >
                      <img
                          @click="slideTo(key)"
                          :src="slide.src"
                          style="cursor: pointer; object-fit: cover"
                          class="d-block px-2 img-fluid rounded"
                          alt="..."
                          width="500"
                          title=""
                      />
                    </Slide>
                  </Carousel>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="selectedEstate.with_collection">
        <div class="col-lg-2 text-lg-center mt-5">
          <span class="fw-bold h5">مورد های مشابه ملکی</span>
        </div>
        <div class="col-lg-12 mt-4" id="infinite_list">
          <div
              v-show="isFirstLoading === true"
              class="container loading-skeleton"
          >
            <div class="row">
              <div class="col-md-6 col-lg-4" v-for="i in 9" :key="i">
                <div class="card mb-3">
                  <img
                      src="//placekitten.com/300/200"
                      class="card-img-top rounded"
                      alt="..."
                  />
                  <div class="card-body rounded-bottom">
                    <h5 class="card-title">Card title</h5>
                    <h5 class="card-title">Card title</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="isFirstLoading === false" class="row image-title-right">
            <div
                v-for="estate in estates"
                :key="estate.shared_token"
                class="col-12 col-sm-6 col-lg-4 mb-4"
            >
              <router-link
                  class="shadow mb-4 mb-lg-0 w-100 rounded-bottom"
                  :to="{
                name: 'details',
                params: { id: estate.shared_token },
              }"
              >
                <img
                    v-if="estate.image === null"
                    src="../assets/images/about-us/homeplus.jpg"
                    class="card-img-top image-estate rounded-top"
                    alt="..."
                    title=""
                />
                <img
                    v-else
                    :src="estate.image.src"
                    class="card-img-top image-estate rounded-top"
                    alt="..."
                    title=""
                />
                <div class="d-flex p-2 gap">
                <span v-if="estate.transaction_type" class="d-block text-muted">
                  {{ getTransactionType(estate.transaction_type) }}
                </span>
                  <span v-if="estate.estate_type" class="d-block text-muted">
                  {{ getEstateType(estate.estate_type) }}
                </span>
                  <span v-if="estate.direction" class="d-block text-muted">
                  {{ getDirection(estate.direction) }}
                </span>
                  <span v-if="estate.region" class="d-block text-muted">
                  {{ getRegion(estate.region) }}
                </span>
                </div>
              </router-link>
            </div>
            <div
                class="col-12 col-sm-6 col-lg-4 mb-4 d-flex justify-content-center align-items-center"
            >
              <div v-if="isPaginateLoading" class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
            <div ref="infinitescrolltrigger" id="scroll-trigger"></div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {Carousel, Navigation, Pagination, Slide} from "vue3-carousel";

export default {
  name: "DetailsEstate",
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  data() {
    return {
      estates: [],
      currentSlide: 0,
      isFirstLoading: true,
      isPaginateLoading: false,
      page: 1,
      visible: false,
      numberphone: null,
      full_name: null,
      errorMessege: null,
      selectedEstate: {
        id: null,
        image: [],
        type: null,
        logs: [],
        region: {
          id: null,
          name: null,
        },
        from: "",
        transaction_type: null,
        change_amount_percent: null,
        change_rent_amount_percent: null,
        direction: null,
        estate_type: null,
        area: null,
        amount: null,
        rent_amount: null,
        age: null,
        count_sleep_room: null,
        floor: null,
        unit_number_of_floor: null,
        unit_number: null,
        document: null,
        description: null,
        is_vip: null,
        has_elevator: null,
        has_terrace: null,
        has_parking: null,
        has_warehouse: null,
        accepted_at: null,
        created_at: null,
        updated_at: null,
        deleted_at: null,
      },
    };
  },
  computed: {
    pageCount() {
      return Math.ceil(this.totalResults / this.maxPerPage);
    },
    pageOffset() {
      return this.maxPerPage * this.currentPage;
    },
    pricePerMeter() {
      if (
          this.selectedEstate.amount != null &&
          this.selectedEstate.area != null
      ) {
        return new Intl.NumberFormat().format(
            Math.floor(this.selectedEstate.amount / this.selectedEstate.area)
        );
      }
    },
  },
  methods: {
    slideTo(val) {
      this.currentSlide = val;
    },
    findId() {
      var found = this.selectedEstates.find((selectedEstate) => {
        return selectedEstate.id == this.selectedEstateid;
      });
    },
    getData() {
      this.isFirstLoading = true
      this.axios
          .get("https://api.amlakplus.app/v2/estate/" + this.$route.params.id)
          .then((res) => {
            if (res.status === 200) {
              this.selectedEstate = res.data.data.estate;
              this.estates = res.data.data.recommends;
            }
          })
          .catch((error) => {
            this.errorEstate = error;
            if (error.response.status === 422) {
              this.$router.push("/error");
            }
          })
          .finally(() => this.isFirstLoading = false);
    },
    onChange(entry) {
      this.visible = entry.isIntersecting;
    },
    getEstates() {
      this.axios
          .get("https://api.amlakplus.app/haghi-estate?page=" + this.page)
          .then((res) => {
            if (res.status === 200) {
              this.estates.push(...res.data.data);
              this.isFirstLoading = false;
            }
          });
    },
    errorEstate() {
      this.axios
          .get(
              `https://api.amlakplus.app/v1/estate/${this.$route.params.id}/phone`
          )
          .then((res) => {
            if (res.status === 200) {
              this.numberphone = res.data.data.phone;
              this.full_name = res.data.data.full_name;
            }
          })
          .catch((res) => {
            this.errorMessege = "درخواست با خطا مواجه شد";
          });
    },
    getTransactionType(value) {
      if (value === "SALE") {
        return "خرید و فروش";
      } else if (value === "RENT") {
        return "رهن و اجاره";
      } else if (value === "PARTNERSHIP") {
        return "مشارکت";
      } else if (value === "PRESELL") {
        return "پیش فروش";
      }
    },
    getEstateType(value) {
      if (value === "VILLA") {
        return "ویلایی";
      } else if (value === "APARTMENT") {
        return "آپارتمان";
      } else if (value === "EARTH") {
        return "زمین";
      }
    },
    getDirection(value) {
      if (value === "WEST") {
        return "غربی";
      } else if (value === "EAST") {
        return "شرق";
      } else if (value === "NORTH") {
        return "شمال";
      } else if (value === "SOUTH") {
        return "جنوب";
      }
    },
    getRegion(value) {
      return value.name;
    },
    getImage(value) {
      return value.src;
    },
    incrementPage() {
      this.page++;
    },
  },
  mounted() {
    this.getData();
  },
  updated() {
    this.$store.commit("toolBar", {
      pageTitle:
          `املاک پلاس | ` +
          this.getTransactionType(this.selectedEstate.transaction_type) +
          ` در ` +
          this.getEstateType(this.selectedEstate.estate_type) +
          ` ` +
          this.selectedEstate.region.name,
    });
  },
  watch: {
    "$route.params.id"() {
      this.getData();
    },
  },
};
</script>

<style scoped>
.carousel__item {
  min-height: 250px;
  width: 100%;
  background-color: var(--vc-clr-primary);
  color: var(--vc-clr-white);
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: gray;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}

.slash::before {
  content: "";
  display: "";
  width: 1px;
  height: 35px;
  background-color: rgba(0, 0, 0, 0.2);
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0);
  }
}

@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(24px, 0);
  }
}

.spinner-wrapper {
  position: fixed; /* Fixed position to cover the entire viewport */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9); /* Optional: change or remove background */
  display: flex;
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
  z-index: 9999; /* On top of everything */
}

.spinner {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: radial-gradient(farthest-side, #474bff 94%, #0000) top/9px 9px no-repeat,
  conic-gradient(#0000 30%, #474bff);
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 9px), #000 0);
  animation: spinner-c7wet2 1s infinite linear;
}

@keyframes spinner-c7wet2 {
  100% {
    transform: rotate(1turn);
  }
}
</style>